import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SmallMobileWidth, pmBlack, pmWhite } from '../sharedData/Constants';
import GeneralContext from '../contexts/GeneralContext';

const Radio = (props) => {

	const [isChecked, setIsChecked] = useState(false);

	const changeEvents = (event) => {
		setIsChecked(event.target.checked);
	};

	useEffect(() => {
		props.setIsValidCheck(isChecked);
		props.verifyValidForm();
	}, [isChecked, props]);

	return (
        <GeneralContext.Consumer>
            {data => (
            <StyledRadioContainer>
                <StyledLabel theme={data.theme}>
                   {props.text}&nbsp;
                    <input
                        type="checkbox"
                        value="accept"
                        checked={isChecked}
                        onChange={changeEvents}
                    />
                    <span className="checkmark"></span>
                    { props.link ? 
                    <StyledLink target='_blank' href="https://www.pmweb.com.br/politica-de-privacidade/">
                        políticas de privacidade.
                    </StyledLink> : null}
                </StyledLabel>
            </StyledRadioContainer>
            )}
        </GeneralContext.Consumer>
	);
};


const StyledRadioContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 5px;
    font-size: 14px;
`;

const StyledLabel = styled.label`
    font-size: 16px;
    justify-content: center;
    display: flex;
    height: 25px;
    align-items: center;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    color: ${props => props.theme === 'dark'? pmWhite : pmBlack};
    @media screen and (max-width: ${SmallMobileWidth}) {
        font-size: 12px;
        letter-spacing: -1px;
    }
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

    input:checked ~ .checkmark:after {
        display: block;
    }
    input{
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .checkmark{
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color:none;
        border-radius: 50%;
        border: 1px solid ${pmWhite};
    }
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
		top: 4px;
        left: 4px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: ${pmWhite};
    }
`;

const StyledLink = styled.a`
    color: inherit;
`;

export default Radio;